function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 51C47 69.5 22 64.5 13 51L11.5 49.5L10 38.5L14.5 23L22.5 12L42 10L63.5 29.5C63.5 35.5 62.8 48.2 60 51Z",
  fill: "#FFB981"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5 38H56.5",
  stroke: "#6D563D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5 36L55.5 34.5",
  stroke: "#6D563D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15 37L17 38",
  stroke: "#6D563D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 34C48.5 34 44.5 35.5 44 39.5V44.5C45.3333 44.6667 48.5 44.9 50.5 44.5C52.5 44.1 51.6667 44 51 44L50 37C50.1667 36 50.3 34 49.5 34Z",
  fill: "#F8FDF5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9792 34.0417C47.9931 38.0347 47.0156 43.0052 51.5 44.5C55 43.5 55 42 55 39.5C55 37.1726 54.1333 34.4118 49.9792 34.0417Z",
  fill: "#6D563D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M50 34C49.993 34.0139 49.9861 34.0278 49.9792 34.0417M51.5 44.5C55 43.5 55 42 55 39.5C55 37.1726 54.1333 34.4118 49.9792 34.0417M51.5 44.5C49.1 44.9 45.5 44.6667 44 44.5V39.5C44 35.5 48 34 49 34C49.3451 34 49.6712 34.0143 49.9792 34.0417M51.5 44.5C47.0156 43.0052 47.9931 38.0347 49.9792 34.0417",
  stroke: "#6D563D",
  strokeWidth: 0.8
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 50.5C34 56 41 55 44.5 50.5",
  stroke: "#AA6F41"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M51.5 3.5C46.5 0.500002 41 -0.999998 37 2.5L36 2C31 -1 28 1 20.5 5C13 9 10 18 9.5 23C9 28 4.99998 38 1.99998 43C-1.00002 48 0.999976 54.5 2.99998 56.5C4.99998 58.5 4.99998 59 3.99998 61.5C4.79998 67.9 9.33331 70.5 11.5 71V69C13.9 70.6 15.8333 70.6667 16.5 70.5C15.5 69.5 14.5 67 16 62.5C17.5 58 16.5 56.5 14.5 53.5C12.5 50.5 12 43 15.5 29C20.5 29 23.5 24 25 18C31 31.5 47.5 32 59 29C59 31.5 59.3 37.8 60.5 43C62 49.5 59.5 53 58 55.5C56.5 58 57 61.5 58 63.5C59 65.5 59.5 68 56.5 71C59.3 71.4 61.3333 69.8333 62 69L62.5 71.5C62.8333 71.3333 64.2 70.4 67 68C70.5 65 69.5 63.5 69 61C68.5 58.5 69 57.5 71.5 55.5C74 53.5 74 47.5 70.5 42C67 36.5 65.5 27.5 63.5 20C61.5 12.5 56.5 6.5 51.5 3.5Z",
  fill: "#484747"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00002 56C5.50002 54.5 3.00002 50 6.00002 47V48C5.00004 50.5 6.00002 51.5 8.5 54C11 56.5 9.5 58.5 9 61.5C8.5 64.5 8.5 65 9.5 66.5C10.5 68 11 67.5 10.5 70.5L9 69.5C6.5 68 4.5 63.5 5.5 61C6.5 58.5 6.50002 57.5 6.00002 56Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M67.5 55C69 53 71.5 50 67 46.5L67.5 48C68 50.5 68 51.5 66 54C64 56.5 63.5 58 64.5 61C65.5 64 65.5 64.5 63 67C61 69 61.8333 70.5 62.5 71L63.5 70.5C69.5 66 69 62.5 67.5 60.5C66 58.5 66 57 67.5 55Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 39C17.5 38 18.5 34 23.5 34L24.5 44.5H20.5C19 44.5 17.5 43.5 17.5 41.5V39Z",
  fill: "#F8FDF5"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 44.5V40.5C29.5 37.1817 26.8034 34.3129 23.9668 34.0239C20.5095 36.5443 22.0079 43.5016 24.5 44L25 44.5H29.5Z",
  fill: "#6D563D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 44.5V40.5C29.5 37.1817 26.8034 34.3129 23.9668 34.0239M29.5 44.5H21M29.5 44.5H25M21 44.5C18.5 44.5 17.5 43.5 17.5 41C17.3575 40.1842 17.3265 39.5378 17.5 37.5C18.5 34.5 20.5 34 23.5 34C23.6557 34 23.8115 34.0081 23.9668 34.0239M21 44.5H25M24 34C23.9889 34.0079 23.9778 34.0159 23.9668 34.0239M25 44.5L24.5 44C22.0079 43.5016 20.5095 36.5443 23.9668 34.0239",
  stroke: "#6D563D",
  strokeWidth: 0.8
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26,
  cy: 40,
  rx: 1,
  ry: 2,
  fill: "#483C2A"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 51.5,
  cy: 40,
  rx: 1,
  ry: 2,
  fill: "#483C2A"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37,
  cy: 46,
  rx: 3,
  ry: 2,
  fill: "#F87A47"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 34.5L18 36",
  stroke: "#6D563D"
});

var SvgKat = function SvgKat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kat.b758fcb7.svg";
export { ForwardRef as ReactComponent };